
<template>
	<section>
		<template v-if="type==='edit'">
			<div>
				<vFormItem inline :label="$t('fbb.inbound.inventory_type', { defaultValue: '库存类型' }) + ':'" labelWidth="auto" required prop="inventoryType">
					<vSelect v-model="formData.inventoryType">
						<vOption v-for="item in getInventoryType" :key="item.value" :value="item.value">{{item.label}}</vOption>
					</vSelect>
				</vFormItem>
			</div>
			<div v-if="needBox">
				<vFormItem inline :label="$t('fbb.inbound.order_box_receive', { defaultValue: '按箱接收' }) + ':'" labelWidth="auto">
					<vInput
						v-model="formData.containerNo"
						readonly
						suffix="search"
						@on-icon-click="handleContainerNo"
					></vInput>
				</vFormItem>
				<vButton theme="primary" class="margin-left-30" @click="addItemByBox">{{$t('global.common.add', { defaultValue: '添加' })}}</vButton>
			</div>
			<div>
				<vFormItem inline :label="$t('fbb.inbound.order_sku_receive', { defaultValue: '按SKU接收' }) + ':'" labelWidth="auto">
					<vSelect v-model="formData.sku" filterable clearable>
						<vOption v-for="val in skuList" :key="val" :value="val">{{val}}</vOption>
					</vSelect>
				</vFormItem>
				<vFormItem inline :label="$t('fbb.accountmanage.amount', { defaultValue: '数量' }) + ':'" labelWidth="auto">
					<vInputNumber clearable v-model="formData.qty" :min="1" math="round" />
				</vFormItem>
				<vButton theme="primary" class="margin-left-30" @click="addItemBySku">{{$t('global.common.add', { defaultValue: '添加' })}}</vButton>
			</div>
			<vButtonGroup class="margin-bottom-10">
				<vButton theme="primary" @click="receiveItems">{{$t('fbb.inbound.order_one_button_receive', { defaultValue: '一键接收' })}}</vButton>
				<vButton theme="success" @click="importItems">{{$t('global.common.import', { defaultValue: '导入' })}}</vButton>
				<vButton theme="warning" @click="delItems">{{$t('global.common.delete', { defaultValue: '删除' })}}</vButton>
				<vButton theme="error" @click="clearItems">{{$t('global.common.clear', { defaultValue: '清空' })}}</vButton>
			</vButtonGroup>
		</template>
		<compTableList :columns="getColumns" v-bind="getTableListProps" ref="tableList"></compTableList>
		<compModal
			v-model="modalProps.show"
			v-bind="modalProps"
			@on-close="modalProps.show=false"
			@on-confirm="modalProps.show=false"
		>
			<component
				v-if="modalProps.component"
				:is="modalProps.component"
				v-bind="modalProps.props"
				@on-close="modalProps.show=false"
				v-on="modalProps.on"
			/>
		</compModal>
		<vLoading size="large" transfer :loading="loading"></vLoading>
	</section>
</template>
<script>

import {
	HttpAddInboundItemByBox,
	HttpReceiveInboundItems,
	HttpAddInboundItemBySku,
	HttpImportInboundItems,
	HttpdelInboundItems,
	HttpClearInboundItems,
	HttpInboundOrderPage,
	HttpSkuList} from "@/service/inbound";
import compBoxcodes from './boxcodes';
import mixin from '../mixin';

export default {
	props: ['inboundPlanOrderId', 'needBox'],
	mixins: [mixin],
	components: {
		compTableList: () => import("@components/templates/tablelist"),
		compUpload: () => import("@components/templates/upload"),
		compModal: () => import("@components/templates/modal"),
		compBoxcodes
	},
	data() {
		return {
			type: this.$route.params.type,
			id: this.$route.query.id,
			loading: false,
			startUp: true,
			skuList: [],
			formData: {
				inventoryType: 0,
			},

			modalProps: {
				show: false,
			},
		}
	},
	created() {
		this.getSkuList();
	},
	computed: {
		getTableListProps() {
			return {
				ajaxRequest: HttpInboundOrderPage,
				startUp: this.startUp,
				initFormData: {
					"search[EQ_inboundOrderId]": this.id
				}
			}
		},
		getColumns() {
			return [{
				type: 'selection',
				formName: 'id',
				width: this.type === 'edit' ? 60 : 0
			}, {
				title: "No",
				type: 'index',
				width: 60
			}, {
				title: this.$t('fbb.inbound.case_code', { defaultValue: "箱码" }),
				key: 'cartonBarcode'
			}, {
				title: "SKU",
				key: 'sku'
			}, {
				title: this.$t('fbb.accountmanage.amount', { defaultValue: "数量" }),
				key: "qty",
			}, {
				title: this.$t('fbb.inbound.inventory_type', { defaultValue: "库存类型" }),
				key: 'inventoryType',
				render: (h, { row }) => {
					return (this.getInventoryType.find(item => item.value == row.inventoryType) || {}).label || ""
				}
			}, {
				title: this.$t('global.common.updatedAt', { defaultValue: "更新时间" }),
				key: 'updatedAt'
			}]
		},

	},
	methods: {
		// SKU list
		getSkuList() {
			HttpSkuList({ id: this.inboundPlanOrderId, }).then(res => {
				this.skuList = res.data;
			}).catch(err => {
				this.skuList = [];
			})
		},
		//  查找箱码
		handleContainerNo() {
			this.modalProps = {
				show: true,
				title: this.$t('fbb.inbound.order_find_box_code', { defaultValue: '查找箱码' }),
				width: 1000,
				showFooter: false,
				component: "compBoxcodes",
				props: {
					initFormData: {
						'search[EQ_inboundPlanOrderId]': this.inboundPlanOrderId,
						'search[EQ_itemStatus]': 0,

					},
					startUp: true,
				},
				on: {
					'on-data': (row) => {
						this.modalProps = {};
						this.formData = { containerNo: row.boxBarcode, inboundPlanBoxItemId: row.id, inventoryType: this.formData.inventoryType };
					}
				}
			}
		},
		// 按箱码添加入库执行单明细
		addItemByBox() {
			this.loading = true;
			HttpAddInboundItemByBox({
				inventoryType: this.formData.inventoryType,
				inboundOrderId: this.id,
				inboundPlanOrderId: this.inboundPlanOrderId,
				inboundPlanBoxItemId: this.formData.inboundPlanBoxItemId,
			}).then(res => {
				this.startUp += 1;
				this.loading = false;
				this.formData = { inventoryType: this.formData.inventoryType }
			}).catch(err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			})
		},
		// 按SKU添加入库执行单明细
		addItemBySku() {
			const { sku, qty, inventoryType } = this.formData
			if (!sku || !qty) {
				this.$VMessage.warning(this.$t('fbb.inbound.order_fill_sku_number', { defaultValue: "请填写sku或数量" }));
				return
			}
			this.loading = true;
			HttpAddInboundItemBySku({
				inventoryType,
				inboundOrderId: this.id,
				inboundPlanOrderId: this.inboundPlanOrderId,
				sku,
				qty,
			}).then(res => {
				this.startUp += 1;
				this.loading = false;
				this.formData = { inventoryType: this.formData.inventoryType }
			}).catch(err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			})
		},
		// 一键接收
		receiveItems() {
			this.loading = true;
			HttpReceiveInboundItems({
				inventoryType: this.formData.inventoryType,
				inboundOrderId: this.id,
				inboundPlanOrderId: this.inboundPlanOrderId,
			}).then(res => {
				this.startUp += 1;
				this.loading = false;
			}).catch(err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			})
		},
		//导入接收明细
		importItems() {
			this.modalProps = {
				show: true,
				title: this.$t('fbb.inbound_import_data', { defaultValue: '导入数据' }),
				component: "compUpload",
				showFooter: false,
				width: "middle",
				props: {
					data: {
						inboundOrderId: this.id,
						inboundPlanOrderId: this.inboundPlanOrderId,
					},
					ajaxRequest: HttpImportInboundItems,
					name: "multipartFile",
					download: () => {
						this.handleWebfs("/static/template/inbound_receive.xls", {}, {
							executor: 'download',
							type: 'url'
						});
					},
				},
				on: {
					'on-success': (row) => {
						this.startUp += 1;
						this.modalProps = {};
					}
				},
			}
		},
		clearAll() {
			this.modalProps = {
				show: true,
				title: this.$t('fbb.inbound.order_clear_all', { defaultValue: '清空所有' }),
				alert: 'error',
				ajaxRequest: async () => {
					this.dataList = [];
					return { message: this.$t('global.common.haveto_empty', { defaultValue: "已清空" }) };
				}
			}
		},

		// 删除 接收明细
		delItems() {
			const inboundOrderItemIds = this.$refs.tableList.checkedData;
			if (!inboundOrderItemIds.length) {
				this.$VMessage.warning(this.$t('fbb.inbound.order_choose_data', { defaultValue: "请选择数据" }));
				return
			}
			this.modalProps = {
				show: true,
				title: this.$t('global.common.delete', { defaultValue: '删除' }),
				alert: 'warning',
				params: {
					inboundOrderId: this.id,
					inboundOrderItemIds
				},
				ajaxRequest: HttpdelInboundItems,
				callback: () => {
					this.startUp += 1;
				}
			}
		},
		// 清空接收明细
		clearItems() {
			this.modalProps = {
				show: true,
				title: this.$t('fbb.inbound.order_clear_all', { defaultValue: '清空所有' }),
				alert: 'error',
				params: {
					inboundOrderId: this.id
				},
				ajaxRequest: HttpClearInboundItems,
				callback: () => {
					this.startUp += 1;
				}
			}
		},

	},
}
</script>
